/* eslint-disable object-curly-newline */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { ref, computed } from '@vue/composition-api'
import { parsePhoneNumber, AsYouType } from 'libphonenumber-js'
import phoneCodes from './constans'

export default function usePhone() {
  const phoneNumber = ref('')
  const phoneCode = ref('')
  const fullPhone = ref(null)
  const fullPhones = ref([])

  const phoneCodeOptions = computed(() => phoneCodes)

  const computedPhoneMask = computed(() => {
    let mask = '(###) ###-####'
    switch (phoneCode.value) {
      case 'US':
        mask = '(###) ###-####'
        break
      case 'ES':
        mask = '### ## ## ##'
        break
      case 'AR':
        mask = '# ### ###-####'
        break
      case 'CL':
        mask = '# #### ####'
        break
      default:
        mask = '(###) ###-####'
        break
    }

    return mask
  })

  const validatePhone = (e, dataPhone) => {
    if (phoneCode.value && e) {
      const phoneNumberJS = parsePhoneNumber(e, phoneCode.value)
      if (phoneNumberJS) {
        if (phoneNumberJS.isValid()) {
          dataPhone = phoneNumberJS.number
          fullPhone.value = phoneNumberJS.number

          return true
        }
      }
    }

    return 'Invalid number'
  }

  const validatePhones = (e, phoneInput) => {
    if (phoneInput.code && e) {
      const phoneNumberJS = parsePhoneNumber(e, phoneInput.code)
      if (phoneNumberJS) {
        if (phoneNumberJS.isValid()) {
          phoneInput.phone = phoneNumberJS.number
          fullPhone.value = phoneNumberJS.number

          return true
        }
      }
    }

    return 'Invalid number'
  }

  const initPhoneConfig = phone => {
    const config = {
      phone_number: '',
      code: '',
    }
    if (phone.includes('+1')) {
      config.code = 'US'
      config.phone_number = phone.substring(2, phone.length)
    }
    if (phone.includes('+34')) {
      config.code = 'ES'
      config.phone_number = phone.substring(3, phone.length)
    }
    if (phone.includes('+54')) {
      config.code = 'AR'
      config.phone_number = phone.substring(3, phone.length)
    }
    if (phone.includes('+56')) {
      config.code = 'CL'
      config.phone_number = phone.substring(3, phone.length)
    }

    return config
  }

  const formatNumber = phone => new AsYouType().input(phone)

  return {
    // data
    phoneNumber,
    phoneCode,
    fullPhone,
    fullPhones,

    // computed
    phoneCodeOptions,
    computedPhoneMask,

    // methods
    validatePhone,
    validatePhones,
    initPhoneConfig,
    formatNumber,
  }
}
